import { useEffect } from "react";

const SITE_URL = "https://www.soft-pro.nl";

const upsertMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description }) => {
  useEffect(() => {
    const path = window.location.pathname === "/" ? "/" : window.location.pathname.replace(/\/$/, "");
    const url = SITE_URL + path;
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertCanonical(url);
  }, [title, description]);
};

export default useSeo;
